<ion-content class="theme-{{userService.theme}}">
    <ion-header [ngClass]="userService.theme" class="transparent absolute">
        <app-header [backRoute]="backRoute" [middleIcon]="false" [socialIcons]="true"
                    [middleIconMobile]="false" [hide930]="true"></app-header>
    </ion-header>
    <div [ngClass]="'bg-inner-'+userService.theme" class="step-wrap">
        <div class="content-wrap-inner">
            <img class="side-logo" [src]="userService.companyLogo">
            <div class="header-text" [@enter] *ngIf="userInfo !== null">{{userTemplate.template.name}}</div>

            <div class="progress" [@enter]>
                <div class="text desktop-only">{{"__JOURNEY_PROGRESS__" | translate}}</div>
                <div class="steps">
                    <img src="assets/img/grey-arrow-back.svg"
                         *ngIf="platform === 'website' && slideCurrent <= 1 && !getPrevPageStage()" (click)="prev(slideCurrent > 1)" class="arrow-back hide930">
                    <img [src]="userService.headerMode === 'light' ? 'assets/img/arrow-back-black.svg' : 'assets/img/arrow-back.svg'"
                         *ngIf="platform === 'website' && slideCurrent > 1 && !getPrevPageStage()" (click)="prev(slideCurrent > 1)" class="arrow-back hide930">
                    <img *ngIf="getPrevPageStage()" src="assets/icon/double-prev.svg" (click)="prev(slideCurrent > 1)" class="arrow-back hide930">

                    <ng-container *ngFor="let step of stageArray; let i = index; let last = last;">
                        <div class="step"
                             *ngIf="isCurrentDecade(step)"
                             [ngClass]="{
                             'last': last || isLastInDecade(step),
                             'active': step <= this.currentStage,
                             'disabled': stageActiveArray.indexOf(i+1) < 0
                         }">
                            <div class="circle" (click)="goToStage(step)">{{step}}</div>
                            <div class="smash" *ngIf="!last && !isLastInDecade(step)"></div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="!getNextPageStage()">
                        <ng-container *ngFor="let step of emptyArray">
                            <div class="step step-empty">
                                <div class="circle">-</div>
                            </div>
                        </ng-container>
                    </ng-container>
                    <img *ngIf="getNextPageStage()" src="assets/icon/double-prev.svg" (click)="next(slideCurrent < slidesTotal)" class="arrow-forward hide930">
                    <img src="assets/img/grey-arrow-back.svg"
                         *ngIf="platform === 'website' && slideCurrent >= slidesTotal && !getNextPageStage()" (click)="next(slideCurrent < slidesTotal)"  class="arrow-forward hide930">
                    <img [src]="userService.headerMode === 'light' ? 'assets/img/arrow-back-black.svg' : 'assets/img/arrow-back.svg'"
                         *ngIf="platform === 'website' && slideCurrent < slidesTotal  && !getNextPageStage()" (click)="next(slideCurrent < slidesTotal)" class="arrow-forward hide930">
                </div>
            </div>
        </div>


    </div>

    <ion-slides class="page-width-and-shadow" [scrollbar]="true" [options]="slideOpts" (ionSlidesDidLoad)="slideDidLoad($event)"
                (ionSlideDidChange)="slideChanged($event)">
        <ng-container *ngIf="stageActiveArrayValid">
            <ion-slide *ngFor="let stage of stageActiveArray; let i = index;">
                <app-learning-journey-skeleton-template
                        *ngIf="pageData[i] === null"></app-learning-journey-skeleton-template>

                <div [ngSwitch]="pageData[i].stage.details.type"
                     [class]="pageData[i].stage.details.type"
                     [ngClass]="{'footer-block': isSaveList || isSaveProgram}"
                     *ngIf="pageData[i] !== null">
                    <app-learning-journey-text-template
                            *ngSwitchCase="'text'"
                            [stage]="pageData[i].stage">
                    </app-learning-journey-text-template>

                    <ng-container *ngSwitchCase="'list'">
                        <ion-content #container>
                            <app-learning-journey-list-template
                              class="page-box journey-box-shadow"
                              (goToStage)="goToStage($event)"
                              (doChangeSaveButton)="onChangeListSaveButton($event)"
                              [container]="container"
                              [stage]="pageData[i].stage"
                              [list]="pageData[i].details.list">
                            </app-learning-journey-list-template>
                        </ion-content>
                        <ion-footer *ngIf="isSaveList" class="swiper-no-swiping">
                            <app-footer (saveEvent)="onSaveList()" [backButton]="true" [saveButton]="true"></app-footer>
                        </ion-footer>
                    </ng-container>

                    <ng-container *ngSwitchCase="'program'">
                        <ion-content>
                            <app-learning-journey-programm-template
                                    (doChangeSaveButton)="onChangeProgramSaveButton($event)"
                                    [stage]="pageData[i].stage"
                                    [programDelegate]="pageData[i].details.program_delegate"
                                    [saveForm]="saveForm"
                                    [level]="'learner'">
                            </app-learning-journey-programm-template>
                        </ion-content>
                        <ion-footer *ngIf="isSaveProgram" class="swiper-no-swiping">
                            <app-footer (saveEvent)="onSave()" [backButton]="true" [saveButton]="true"></app-footer>
                        </ion-footer>
                    </ng-container>
                </div>
            </ion-slide>
        </ng-container>
    </ion-slides>
</ion-content>
